import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import SlideRightDialog from '../../../../../components/common/SlideRightDialog';
import Step1 from './Step1';
import PersonalInfoConsentForm from './PersonalInfoConsentForm';
import Step3 from './Step3';

const Kakao = ({ isOpen, modalCloseHandler, handleAuthentication }) => {
  const { t } = useTranslation('resultQuery');

  //1: 개인정보입력, 2: 개인정보 수집 이용 제3자 제공동의서, 3: 완료
  const [step, setStep] = useState(1);
  const [kakaoData, setKakaoData] = useState({});
  // 토스 카카오 선택
  const [selectedItem, setSelectedItem] = useState(0);
  //동의하기 체크
  const [check, setCheck] = useState(false);

  const stepHandler = step => {
    console.log('step', step);
    setStep(step);
  };

  const onCloseHandler = close => {
    console.log('step', step);
    console.log('close', close);

    if (step == 2) {
      setStep(1);
    } else {
      modalCloseHandler();
    }
  };

  const handleCheck = () => {
    setCheck(true);
    stepHandler(1);
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onCloseHandler} title={t('signItem4')}>
      {step === 1 && (
        <Step1
          stepHandler={stepHandler}
          setKakaoData={setKakaoData}
          {...{ selectedItem, setSelectedItem, check, setCheck }}
        />
      )}
      {step === 2 && (
        <PersonalInfoConsentForm
          stepHandler={stepHandler}
          {...{ handleCheck, modalCloseHandler }}
        />
      )}
      {step === 3 && (
        <Step3
          stepHandler={stepHandler}
          onCloseHandler={onCloseHandler}
          {...{ handleAuthentication, kakaoData, selectedItem, modalCloseHandler }}
        />
      )}
    </SlideRightDialog>
  );
};

export default Kakao;
